import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import Dashboard from "./pages/Dashboard";
import Integrations from "./pages/Integrations";
import Settings from "./pages/BotSettings";
import SplashScreen from "./components/SplashScreen";
import NumberBlocking from "./pages/NumberBlocking";
import ProductsServices from "./pages/ProductsServices";
import CRM from "./pages/CRM";
import WhatsAppLink from "./pages/WhatsAppLink";
import Plans from "./pages/Plans";
import Login from "./pages/Login";
import Chatbot from "./pages/Chatbot";
import KnowledgeBase from "./pages/KnoledgeBase";
import Register from "./pages/Register";
import VerificationSuccess from "./pages/verfi_page";
import ChatBubble from "./components/help_sec";
import Landing from "./pages/MainPage";
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import AuthCallback from "./pages/callback";

// ✅ Component للفحص المستمر للـ token
function TokenVerifier({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setIsAuthenticated(false);
        navigate("/login");
        return;
      }

      try {
        // ✅ جرب تعمل أي API call لفحص الـ token
        const res = await fetch("https://zaichat.net/api/product", {
          headers: {
            auth: `Bearer ${token}`,
          },
        });

        if (res.status === 401) {
          // ❌ Token منتهية الصلاحية
          localStorage.removeItem("token");
          setIsAuthenticated(false);
          toast.error("Session expired. Please login again.");
          navigate("/login");
        }
      } catch (err) {
        console.error("Token verification error:", err);
      }
    };

    // ✅ فحص الـ token عند كل تغيير في الصفحة
    if (localStorage.getItem("token")) {
      verifyToken();
    }

    // ✅ فحص دوري كل دقيقة (اختياري)
    const interval = setInterval(() => {
      if (localStorage.getItem("token")) {
        verifyToken();
      }
    }, 60000); // كل دقيقة

    return () => clearInterval(interval);
  }, [location.pathname, navigate, setIsAuthenticated]);

  return null;
}

export default function App() {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // ✅ Check authentication state
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      if (token) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    };

    // Run after splash screen
    if (!loading) checkAuth();

    // Listen to localStorage changes (login/register/logout)
    window.addEventListener("storage", checkAuth);

    return () => {
      window.removeEventListener("storage", checkAuth);
    };
  }, [loading]);

  if (loading) {
    return <SplashScreen onFinish={() => setLoading(false)} />;
  }

  return (
    <Router>
      <Toaster position="bottom-right" />

      {!isAuthenticated ? (
        // 🔒 Not logged in → show Login/Register routes only
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify" element={<VerificationSuccess />} />
          <Route path="/" element={<Landing />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      ) : (
        // ✅ Logged in → show main dashboard layout
        <div className="flex flex-col md:flex-row relative">
          {/* ✅ فحص الـ token باستمرار */}
          <TokenVerifier setIsAuthenticated={setIsAuthenticated} />

          <Sidebar />
          <div className="flex-1 min-h-screen bg-cream transition-all duration-500 md:ml-64">
            <div className="p-4 sm:p-6 md:p-8">
              <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/crm" element={<CRM />} />
                <Route path="/kowledge" element={<KnowledgeBase />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/numbers" element={<NumberBlocking />} />
                <Route path="/products" element={<ProductsServices />} />
                <Route path="/whatsapp" element={<WhatsAppLink />} />
                <Route path="/chatbot" element={<Chatbot />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/verify" element={<VerificationSuccess />} />

                {/* Prevent going back to login/register while logged in */}
                <Route path="/login" element={<Navigate to="/dashboard" />} />
                <Route
                  path="/register"
                  element={<Navigate to="/dashboard" />}
                />
                <Route path="/" element={<Navigate to="/dashboard" />} />
              </Routes>
            </div>
          </div>

          {/* ✅ فقاعة الشات تظهر في جميع الصفحات بعد تسجيل الدخول */}
          <ChatBubble />
        </div>
      )}
    </Router>
  );
}
